<template>
	<div id="simple-calendar-app">
		<div class="vx-card no-scroll-content">
			<calendar-view
				ref="calendar"
				class="theme-default"
				locale="pt-br"
				eventBorderHeight="0px"
				eventContentHeight="50px"
				:displayPeriodUom="calendarView"
				:displayPeriodCount="1"
				:show-date="showDate"
				:events="prazos"
				eventTop="3rem"
			>
				<div slot="header" class="mb-4">
					<div class="vx-row justify-between ">
						<div class="vx-col flex justify-start w-1/3 my-3">
							<div class="flex items-center">
								<feather-icon
									:icon="
										$vs.rtl
											? 'ChevronRightIcon'
											: 'ChevronLeftIcon'
									"
									@click="previousDate(-1)"
									svgClasses="w-5 h-5 m-1"
									class="cursor-pointer bg-primary text-white rounded-full"
								/>

								<span
									v-if="calendarView == 'week'"
									style="min-width: 137px;"
									class="mx-3 text-xl text-center font-medium whitespace-no-wrap"
								>
									{{ getWeekOfMoth(showDate) }}ª semana de
									{{ showDate | moment("MMMM YYYY") }}
								</span>
								<span
									v-else
									style="min-width: 137px;"
									class="mx-3 text-xl text-center font-medium whitespace-no-wrap"
									>{{ showDate | moment("MMMM YYYY") }}</span
								>

								<feather-icon
									:icon="
										$vs.rtl
											? 'ChevronLeftIcon'
											: 'ChevronRightIcon'
									"
									@click="nextDate(1)"
									svgClasses="w-5 h-5 m-1"
									class="cursor-pointer bg-primary text-white rounded-full"
								/>
							</div>
						</div>

						<div class="vx-col w-1/3 flex justify-center">
							<template
								v-for="(view, index) in calendarViewTypes"
							>
								<vs-button
									v-if="calendarView === view.val"
									:key="String(view.val) + 'filled'"
									type="filled"
									class="p-3 md:px-8 md:py-3"
									:class="{
										'border-l-0 rounded-l-none': index,
										'rounded-r-none':
											calendarViewTypes.length !==
											index + 1
									}"
									@click="() => view.callback(view.val)"
									>{{ view.label }}</vs-button
								>
								<vs-button
									v-else
									:key="String(view.val) + 'border'"
									type="border"
									class="p-3 md:px-8 md:py-3"
									:class="{
										'border-l-0 rounded-l-none': index,
										'rounded-r-none':
											calendarViewTypes.length !==
											index + 1
									}"
									@click="() => view.callback(view.val)"
									>{{ view.label }}</vs-button
								>
							</template>
						</div>

						<div class="vx-col w-1/3 items-center justify-end flex">
							<vs-button
								v-if="
									$permissions.can('autenticadosuperuser') ||
										$permissions.can('prazoadicionar')
								"
								icon-pack="feather"
								icon="icon-plus"
								class="mr-2"
								@click="showPopupAdicionarPrazo"
								>Novo prazo</vs-button
							>
						</div>
					</div>

					<div class="vx-row sm:flex hidden mt-4">
						<div class="vx-col w-full flex">
							<div
								class="flex flex-wrap p-5 sm:justify-start justify-center"
							>
								<div
									v-for="(label, index) in calendarLabels"
									:key="index"
									class="flex items-center mr-4 mb-2"
								>
									<div
										class="h-4 w-4 inline-block rounded-full mr-2"
										:style="
											`background-color: ${label.color}`
										"
									></div>
									<span>{{ label.text }}</span>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div
					:title="event.title"
					slot="event"
					slot-scope="{ event, weekStartDate, top }"
					:class="[
						event.classes,
						{
							'pl-0':
								event &&
								event.originalEvent &&
								event.originalEvent.responsavel &&
								event.originalEvent.responsavel.fotoThumb
						}
					]"
					class="flex items-center cv-event bg-primary"
					:style="
						`top: ${top}; background: ${
							event && event.originalEvent
								? event.originalEvent.labelColor
								: ''
						} !important; min-height: 40px; max-height: 40px`
					"
					@click="openEditEvent(event.originalEvent.pk)"
				>
					<div class="card-event-content">
						<div
							class="flex flex items-center flex-1 overflow-hidden pointer-events-none"
						>
							<vs-avatar
								v-if="
									event &&
										event.originalEvent &&
										event.originalEvent.responsavel &&
										event.originalEvent.responsavel
											.fotoThumb
								"
								class="m-0"
								:src="event.originalEvent.responsavel.fotoThumb"
							/>

							<h6 class="title-event">
								{{
									event && event.originalEvent
										? event.originalEvent.titulo
										: "Sem tituto"
								}}
							</h6>
						</div>
						<div
							class="icons-container relative flex flex-col items-end justify-between"
						>
							<div class="icon-bookmark-container">
								<img
									v-if="
										event && event.originalEvent
											? event.originalEvent.prioridade
											: false
									"
									:src="BookmarkIcon"
								/>
							</div>
							<div class="flex">
								<img
									class="mb-1"
									v-if="
										(event && event.originalEvent
											? event.originalEvent.ciente
											: false) && !(event && event.originalEvent
											? event.originalEvent.cumprido
											: false)
									"
									:src="CheckIcon"
								/>
								<img
									class="mb-1"
									v-if="
										(event && event.originalEvent
											? event.originalEvent.cumprido
											: false) && (event && event.originalEvent
											? event.originalEvent.ciente
											: false)
									"
									:src="DoubleCheckIcon"
								/>
							</div>
						</div>
					</div>
				</div>
			</calendar-view>
		</div>

		<popup-adicionar-prazo
			:active.sync="activePopupAdicionarPrazo"
			:prazoCopy="prazoDuplicate"
			:closed="closeEditOrCreatePrazo"
		/>

		<popup-editar-prazo
			:active.sync="activePopupEditarPrazo"
			:prazoPk="targetPrazoPk"
			:closed="closeEditOrCreatePrazo"
			:duplicate="onDuplicatePrazo"
		/>
	</div>
</template>

<script>
require("vue-simple-calendar/static/css/default.css");
import { CalendarView } from "vue-simple-calendar";

import Prazo, { Situacao } from "../../../../../models/Prazo";
import PopupAdicionarPrazo from "./popup_adicionar_prazo/PopupAdicionarPrazo";
import PopupEditarPrazo from "./popup_editar_prazo/PopupEditarPrazo";

import StringHelper from "../../../../../helpers/StringHelper";

import { mapState } from "vuex";
import moment from "moment";

export default {
	data() {
		return {
			prazoDuplicate: null,
			targetPrazoPk: null,
			showDate: new Date(),
			calendarView: "week",
			activePopupAdicionarPrazo: false,
			activePopupEditarPrazo: false,
			prazos: [],
			loadingPrazos: null,
			isReloading: false,
			DoubleCheckIcon: require("../../../../../assets/images/icons/DoubleCheckIcon.svg"),
			BookmarkIcon: require("../../../../../assets/images/icons/BookmarkIcon.svg"),
			CheckIcon: require("../../../../../assets/images/icons/CheckIcon.svg"),
		};
	},
	components: {
		CalendarView,
		PopupAdicionarPrazo,
		PopupEditarPrazo
	},
	computed: {
		calendarLabels() {
			return Situacao.listForLabels();
		},
		empresaPk() {
			try {
				return this.$route.params.empresaPk;
			} catch (error) {
				return null;
			}
		},
		calendarViewTypes() {
			return [
				{
					label: "Mês",
					val: "month",
					callback: val => {
						this.calendarView = val;
						const filters = this.getFilters(this.fitrosCalendarioPrazos);
						this.getPrazos(filters);
					}
				},
				{
					label: "Semana",
					val: "week",
					callback: val => {
						this.calendarView = val;
						const filters = this.getFilters(this.fitrosCalendarioPrazos);
						this.getPrazos(filters);
					}
				},
				{
					label: "Dia",
					val: "day",
					callback: this.navigateToPrazos
				}
			];
		},
		...mapState(["fitrosCalendarioPrazos", "prazoToEditar"])
	},
	methods: {
		getWeekOfMoth(date) {
			const mDate = moment(date);
			const dateMonth = mDate.format("M");
			const endOfWeek = mDate.endOf("week");
			const endOfWeekMonth = endOfWeek.format("M");
			let day = endOfWeek.format("D");

			if (parseInt(endOfWeekMonth, 10) > parseInt(dateMonth, 10)) {
				day = mDate.startOf("week").format("D");
			}

			return Math.ceil(parseInt(day, 10) / 7);
		},
		updateMonth(val) {
			this.showDate = this.$refs.calendar.getIncrementedPeriod(val);
		},
		nextDate(val) {
			this.updateMonth(val);
			const filters = this.getFilters(this.fitrosCalendarioPrazos);
			this.getPrazos(filters);
		},
		previousDate(val) {
			this.updateMonth(val);
			const filters = this.getFilters(this.fitrosCalendarioPrazos);
			this.getPrazos(filters);
		},
		showPopupAdicionarPrazo() {
			this.prazoDuplicate = null;
			this.activePopupAdicionarPrazo = true;
		},
		onDuplicatePrazo(prazo) {
			this.prazoDuplicate = prazo;
			this.activePopupAdicionarPrazo = true;
		},
		openEditEvent(prazoPk) {
			this.targetPrazoPk = prazoPk;
			this.activePopupEditarPrazo = true;
		},
		getEndDateFilter() {
			return moment(this.showDate)
				.endOf(this.calendarView)
				.format('YYYY-MM-DD');
		},
		getStartDateFilter() {
			return moment(this.showDate)
				.startOf(this.calendarView)
				.format('YYYY-MM-DD');
		},
		async getPrazos(filtros) {
			const loading = this.$vsloading({
				color: "#000000",
				backgroundColor: "#ffffffba",
				opacity: 1,
				width: 44,
				height: 44,
				isFullPage: true
			});

			this.loadingPrazos = loading;

			const hideLoading = () => {
				if (loading && typeof loading.hide === "function") {
					setTimeout(() => loading.hide(), 200);
				}

				if (this.loadingPrazos === loading) {
					this.loadingPrazos = null;
				}
			};

			if (!filtros) {
				filtros = {
					ordering: "dt_fim,-prioridade",
					periodo: `${this.getStartDateFilter()},${this.getEndDateFilter()}`,
				}
			} else {
				filtros["ordering"] = "dt_fim,-prioridade";
				filtros["periodo"] = `${this.getStartDateFilter()},${this.getEndDateFilter()}`;
			}

			try {
				const { prazos } = await Prazo.getPrazosPorEmpresa(
					this.empresaPk,
					filtros
				);

				this.prazos = prazos.map(prazo => {
					const id = StringHelper.onlyNumbers(prazo.pk);

					return {
						...prazo,
						id,
						title: prazo.titulo,
						startDate: prazo.dataFim,
						endDate: prazo.dataFim,
						label: prazo.situacao,
						labelColor: prazo.desativado
							? Situacao.getCor("DESATIVADO")
							: Situacao.getCor(prazo.situacao)
					};
				});

			} catch (error) {
				console.error(error);
			} finally {
				hideLoading();
			}
		},
		getFilters(filtros) {
			const filters = {};

			if (filtros) {
				if (filtros.responsaveis) {
					filters["responsavel"] = filtros.responsaveis.join(",");
				}

				if (filtros.status) {
					filters["situacao"] = filtros.status.join(",");
				}

				if (filtros.apenasMeusSupervisionados) {
					filters["supervisor"] = "me";
				}
			}

			return filters;
		},
		navigateToPrazos() {
			this.$navigate({
				name: "empresa-prazo-listar",
				params: { empresaPk: this.empresaPk }
			});
		},
		closeEditOrCreatePrazo() {
			const filters = this.getFilters(this.fitrosCalendarioPrazos);
			this.getPrazos(filters);
			this.atualizarPrazosAlerta();
		},
		atualizarPrazosAlerta() {
			if (this.$store.state.prazoToEditar === null) {
				this.$store.state.prazoToEditar = undefined;
			} else {
				this.$store.state.prazoToEditar = null;
			}
		},
		reloadPrazos() {
			// Evita loop com o watcher
			this.isReloading = true;
			
			// Recarrega os prazos sem filtros
			const filters = this.getFilters(this.fitrosCalendarioPrazos);
			this.getPrazos(filters).finally(() => {
				// Libera o watcher após 100ms
				setTimeout(() => {
					this.isReloading = false;
				}, 100);
			});
		}
	},
	watch: {
		fitrosCalendarioPrazos: {
			deep: true,
			handler(filtros) {
				// Ignora se está fazendo reload manual
				if (this.isReloading) return;
				
				const filters = this.getFilters(filtros);
				this.getPrazos(filters);
			}
		},
		prazoToEditar: {
			deep: true,
			handler(prazoPk) {
				if (prazoPk) {
					this.openEditEvent(prazoPk);
				}
			}
		}
	},
	created() {
		const filters = this.getFilters(this.fitrosCalendarioPrazos);
		this.getPrazos(filters);
	},
	beforeDestroy() {
		if (this.loadingPrazos) {
			this.loadingPrazos.hide();
		}
	}
};
</script>

<style lang="scss">
@import "@/assets/scss/vuesax/apps/simple-calendar.scss";

#simple-calendar-app {
	min-width: 1000px;
}
</style>
